export default __webpack_public_path__ + "static/media/phone-call.00387604.png";